/* =========================================================
 * ebook-checkout.js
 * ---------------------------------------------------------
 * Intercepte le clic sur les cartes e-book (data-ebk-buy)
 * → POST /cart/add.js avec la variante (quantity = 1)
 * → redirection vers /checkout (checkout Shopify natif)
 *
 * Fallback : si le JS échoue ou est désactivé, le navigateur
 * suit le href du <a> qui pointe sur /cart/{variant_id}:1
 * (cart permalink Shopify, garantit toujours l'ajout au panier).
 *
 * 100% Shopify : aucune donnée de paiement n'est manipulée
 * côté thème — tout passe par le checkout Shopify standard.
 *
 * + charge assets/product-gallery.js (galerie interactive des fiches produit).
 * =======================================================*/

(function () {
  'use strict';

  // Galerie produit interactive : chargée depuis le même dossier d'assets
  try {
    var me = document.currentScript || document.querySelector('script[src*="ebook-checkout.js"]');
    if (me && me.src && document.querySelector('.product-media')) {
      var g = document.createElement('script');
      g.src = me.src.replace('ebook-checkout.js', 'product-gallery.js');
      g.defer = true;
      document.head.appendChild(g);
    }
  } catch (err) {}

  // Garde-fou anti double-clic
  var inFlight = false;

  function getCartAddUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart/add.js';
  }

  function getCheckoutUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'checkout';
  }

  function setBusy(el, busy) {
    if (!el) return;
    if (busy) {
      el.setAttribute('aria-busy', 'true');
      el.classList.add('is-loading');
    } else {
      el.removeAttribute('aria-busy');
      el.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', function (e) {
    // Ignore middle/right click + cmd/ctrl-click (nouvel onglet)
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var trigger = e.target.closest('[data-ebk-buy]');
    if (!trigger) return;

    var variantId = trigger.getAttribute('data-variant-id');
    if (!variantId) return;

    // On a tout ce qu'il faut → on intercepte
    e.preventDefault();
    if (inFlight) return;
    inFlight = true;
    setBusy(trigger, true);

    var payload = { id: parseInt(variantId, 10), quantity: 1 };
    // Abonnements : plan de vente (selling plan) transmis au panier
    var sellingPlan = trigger.getAttribute('data-selling-plan');
    if (sellingPlan) payload.selling_plan = parseInt(sellingPlan, 10);

    fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err && err.description ? err.description : 'cart_add_failed');
          });
        }
        return res.json();
      })
      .then(function () {
        // Tout OK → direct checkout Shopify
        // Offre « 1er mois à 1 € » : le code (1 fois par client) est appliqué automatiquement
        var code = trigger.getAttribute('data-discount-code');
        if (code) {
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          if (root.charAt(root.length - 1) !== '/') root += '/';
          window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout');
          return;
        }
        window.location.href = getCheckoutUrl();
      })
      .catch(function () {
        // Fallback : on suit le href natif (/cart/{id}:1 → cart page)
        inFlight = false;
        setBusy(trigger, false);
        var href = trigger.getAttribute('href');
        if (href) window.location.href = href;
      });
  }, false);
})();
